export const logoutLocally = () => {
  localStorage.clear();
  window.location.replace("/"); // TODO bad way, need to refactor screen architecture
};